import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-17969 Отображать ли кнопки шеринга для списка аттачей */
export const shouldPublishButtonsOnAttachList = isFeature('show-publish-buttons-on-attach-list');
